import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosTree } from './tree'
import { IcosTreeItem } from './tree-item'
import { IcosCheckboxsModule } from '../checkbox/module'

@NgModule({
  declarations: [IcosTree, IcosTreeItem],
  exports: [IcosTree, IcosTreeItem],
  imports: [CommonModule, IcosCheckboxsModule],
  entryComponents: [IcosTree],
})
export class IcosTreeModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosTreeModule, providers: []}
  }
}
